import {
	FETCH_USER_APPRECIATION_REQUEST,
	FETCH_USER_APPRECIATION_SUCCESS,
	FETCH_USER_APPRECIATION_FAILURE,
} from '../../constants';

const initialState = {
	data: [],
	loading: false,
	error: null,
};

const userAppreciationsReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_USER_APPRECIATION_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: [],
			};
		case FETCH_USER_APPRECIATION_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case FETCH_USER_APPRECIATION_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: [],
			};
		default:
			return state;
	}
}

export default userAppreciationsReducer;
